<template>
  <content-box class="schema-inspection-guide-modal" width="460px" minHeight="auto">
    <div class="guide-header">
      <h1 class="title">{{ $t('observedSitemap.inspection.guide.title') }}</h1>
      <button class="close-btn" @click="$emit('close')">
        <i class="icon icon--close-btn size-16"></i>
      </button>
    </div>
    <div class="guide-body">
      <p class="description" v-html="$t('observedSitemap.inspection.guide.description')"></p>
      <div class="scope-box">
        <div class="scope-item">
          <span class="label">{{ $t('observedSitemap.inspection.guide.domain') }}</span>
          <span class="value">{{ displayDomain | domain }}</span>
        </div>
        <div class="scope-item">
          <span class="label">{{ $t('observedSitemap.inspection.guide.firstPath') }}</span>
          <span class="value">{{ formattedFirstPath }}</span>
        </div>
      </div>
      <p class="notice" v-html="$t('observedSitemap.inspection.guide.notice')"></p>
    </div>
    <div class="guide-footer">
      <button class="btf-button outline" @click="$emit('close')">
        {{ $t('common.cancel') }}
      </button>
      <button class="btf-button primary outline" @click="$emit('confirm')">
        {{ $t('observedSitemap.inspection.guide.confirm') }}
      </button>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'

export default {
  name: 'BaSchemaInspectionGuideModal',
  components: {
    ContentBox
  },
  props: {
    domain: {
      type: String,
      default: ''
    },
    subDomain: {
      type: String,
      default: ''
    },
    firstPath: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayDomain () {
      if (this.subDomain) return this.subDomain
      return this.domain ? `*.${this.domain}` : '-'
    },
    formattedFirstPath () {
      if (!this.firstPath) return this.$t('common.all')
      return `/${String(this.firstPath).replace(/^\/|\/$/g, '')}/`
    }
  }
}
</script>

<style lang="scss" scoped>
.schema-inspection-guide-modal {
  overflow: hidden;

  .guide-header {
    position: relative;
    padding: 50px 40px 0 40px;
    text-align: center;
  }

  .title {
    margin: 0;
    color: #444;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.35;
  }

  .close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .guide-body {
    padding: 14px 40px 0 40px;
  }

  .description {
    margin: 0;
    color: #767676;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
  }

  .scope-box {
    margin-top: 22px;
    padding: 16px 18px;
    border: 1px solid #d7d7d7;
    border-radius: 8px;
    background-color: #f7f7f7;
  }

  .scope-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    min-height: 24px;
    font-size: 13px;
    line-height: 1.5;

    & + .scope-item {
      margin-top: 8px;
    }
  }

  .label {
    flex: 0 0 78px;
    color: #999;
  }

  .value {
    flex: 1;
    color: #444;
    font-weight: 500;
    word-break: break-all;
  }

  .notice {
    margin: 14px 0 0 0;
    color: #999;
    font-size: 12px;
    line-height: 1.55;
    text-align: center;
  }

  .guide-footer {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 30px 40px 36px 40px;
  }
}
</style>
